
  function toggleClass(ID, CLASS) {
    document.getElementById(ID).classList.toggle(CLASS)
  }
  function addClass(ID, CLASS) {
    document.getElementById(ID).classList.add(CLASS)
  }
  function removeClass(ID, CLASS) {
    document.getElementById(ID).classList.remove(CLASS)
  }